import ServerHeadManagement from './ServerHeadManagement';
import ClientHeadManagement from './ClientHeadManagement';
import favicons from '~/assets/favicons';

/**
 * Helper function to retrieve a property from the vue component
 *
 * The vue component properties must always return a promise in order for
 * server side rendering to work
 *
 * Alternatively they can also be specified as a plain string
 *
 * @param propertyName
 * @param vm
 */
function getProperty(propertyName: string, vm: any): string {
  // components can simply provide a `title` function which returns a promise
  const { [propertyName]: property } = vm;

  if (typeof property === 'function') {
    return property.call(vm);
  } else if (property) {
    return property;
  }

  return '';
}

/*
 * Define properties which can be used to alter the contents of <head>
 * These are injected at ./server/index.template.html and are initialized
 * in render function of ./server/main.js
 */
export function getTitle(vm: any): string {
  return getProperty('title', vm);
}

export function getSeoMeta(vm: any): string {
  return getProperty('seoMeta', vm);
}

export function getInlineCss(vm: any): string {
  return `<style type="text/css">${getProperty('inlineCss', vm)}</style>`;
}

export function getFavicons(): string {
  return favicons;
}

export function replaceDocumentHeadContext(
  contextName: string,
  replacement: string
) {
  const regex = new RegExp(`<!-- ${contextName} -->.*<!-- /${contextName} -->`);
  document.head.innerHTML = document.head.innerHTML.replace(
    regex,
    `<!-- ${contextName} -->${replacement}<!-- /${contextName} -->`
  );
}

export default process.env.VUE_ENV === 'server'
  ? ServerHeadManagement
  : ClientHeadManagement;
